import { denormalizeRate } from "logic/utils";

import { Loan } from "./types";

/**
 * The loan's APR as a fraction (0.12 = 12%) — the single accessor every APR
 * display should go through.
 *
 * Prefers the published figure from the dashboard feed, which is the blended
 * tranche rate PLUS the insurance spread (the `kind: 1` Repayment fee spec on the
 * ratio fee model, annualized ×12) with the backend's per-loan carve-outs applied.
 *
 * Falls back to the bare blended rate when the loan is absent from that feed
 * (non-public, closed, or a clone row the whitelist dedupes). That fallback
 * understates an insured loan by its spread — it is the lesser of two evils
 * against rendering nothing, not a second source of truth. Do not re-derive the
 * APR from tranche rates anywhere else: the carve-outs are not visible here.
 */
export function getLoanApr(loan: Pick<Loan, "apr" | "blendedRate">): number {
  return loan.apr ?? denormalizeRate(loan.blendedRate);
}
